import React from "react";
import { useForm } from "react-hook-form";
import { Button, FlashMessage, Input } from "../../../components/common";
import { useDispatch, useSelector } from "react-redux";
import { setTags } from "../../../reducers/company/companyMarketingSolution.reducer";
import { rootReducersState } from "../../../reducers";

interface TagInputType {
  tag: string;
}

const TagInput = () => {
  const { register, handleSubmit, setValue, watch } = useForm<TagInputType>();
  const dispatch = useDispatch();
  const tags = useSelector(
    ({ company }: rootReducersState) => company.companyMarketingSolution.tags
  );
  const tagValue = watch("tag") || "";

  const onSubmit = (data: TagInputType) => {
    const trimmedTag = data.tag.trim();
    if (!trimmedTag) {
      return;
    }

    const alreadyAdded = (tags || []).some(
      (tag: string) => tag.toLowerCase() === trimmedTag.toLowerCase()
    );
    if (alreadyAdded) {
      FlashMessage("That tag has already been added", "error");
      return;
    }

    dispatch(setTags(trimmedTag));
    setValue("tag", "");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="tags-form">
      <div className="tags-form-row">
        <div className="tags-form-field">
          <Input
            externalLabel={{ label: "Create a tag" }}
            placeholder="e.g. Newsletter, VIP"
            {...register("tag", { required: true })}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(onSubmit)();
              }
            }}
          />
        </div>
        <div className="tags-form-action">
          <Button type="submit" disabled={!tagValue.trim()}>
            Add
          </Button>
        </div>
      </div>
    </form>
  );
};

export default TagInput;
